import { motion } from 'framer-motion';
import Button from '../UI/Button';

// Product-specific welcome content
const welcomeContent = {
  nad: {
    title: 'Vitality',
    therapy: 'NAD+ Therapy',
    subtitle: 'Join thousands who have transformed their energy, clarity, and overall wellness with our personalized anti-aging treatments.',
    benefits: [
      'Boost Energy Levels',
      'Enhance Mental Clarity',
      'Improve Recovery'
    ]
  },
  glutathione: {
    title: 'Glow',
    therapy: 'Glutathione Therapy',
    subtitle: 'Discover the master antioxidant that supports detoxification, immune function, and radiant skin from within.',
    benefits: [
      'Brighten Skin Tone',
      'Support Detoxification',
      'Strengthen Immune System'
    ]
  },
  vitaminb12: {
    title: 'Energy',
    therapy: 'Vitamin B12 Therapy',
    subtitle: 'Experience sustained energy and mental clarity throughout your day with our premium B12 injections.',
    benefits: [
      'Boost Daily Energy',
      'Enhance Mental Focus',
      'Support Nerve Health'
    ]
  },
  lcarnitine: {
    title: 'Performance',
    therapy: 'L-Carnitine Therapy',
    subtitle: 'Optimize your metabolism and athletic performance with targeted fat-burning support.',
    benefits: [
      'Enhance Fat Metabolism',
      'Improve Athletic Performance',
      'Support Weight Management'
    ]
  }
};

export default function WelcomeScreen({ product, onContinue }) {
  const content = welcomeContent[product?.id] || welcomeContent.nad;
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="max-w-2xl mx-auto"
    >
      <div className="bg-white rounded-luxury shadow-luxury p-8">
        <h1 className="text-3xl md:text-4xl font-bold text-charcoal text-center mb-6">
          Unlock Your <span className="text-renuvia-gold">{content.title}</span> with our proven {content.therapy}
        </h1>

        <p className="text-slate text-center mb-8 text-lg">
          {content.subtitle}
        </p>

        <div className="space-y-4 mb-10">
          {content.benefits.map((benefit, index) => (
            <motion.div
              key={benefit}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.2 + index * 0.1 }}
              className="flex items-center gap-3"
            >
              <div className="flex-shrink-0 w-6 h-6">
                <svg className="w-6 h-6 text-renuvia-gold" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              </div>
              <span className="text-charcoal text-lg">{benefit}</span>
            </motion.div>
          ))}
        </div>

        <Button onClick={onContinue} fullWidth>
          Start Your Journey →
        </Button>
      </div>
    </motion.div>
  );
}
